<template>
  <table class="period-table">
    <tr>
      <td>Begin</td>
      <td>
        <date-input v-model="beginDateStr"/>
      </td>
      <td>
        <time-input v-model="beginTimeStr"/>
      </td>
    </tr>
    <tr>
      <td>End</td>
      <td>
        <date-input v-model="endDateStr"/>
      </td>
      <td>
        <time-input v-model="endTimeStr"/>
      </td>
    </tr>
  </table>
</template>

<script>
import DateInput from './DateInput.vue';
import TimeInput from './TimeInput.vue';

import { convertMomentToDataStr } from '../util';
import { convertMomentToTimeStr } from '../util';
import { convertDataStrAndTimeStrToLocalData } from '../util';

export default {
  name: 'PeriodInput',

  components: {
    DateInput,
    TimeInput,
  },

  props: {
    value: {
      required: true,
    },
  },

  data() {
    const beginDateStr = convertMomentToDataStr(this.value.begin);
    const beginTimeStr = convertMomentToTimeStr(this.value.begin);

    const endDateStr = convertMomentToDataStr(this.value.end);
    const endTimeStr = convertMomentToTimeStr(this.value.end);

    return {
      beginDateStr,
      beginTimeStr,

      endDateStr,
      endTimeStr,
    };
  },

  computed: {
    beginMoment() {
      if(this.beginDateStr.length === 0) {
        return null;
      }
      if(this.beginTimeStr.length === 0) {
        return null;
      }
      return convertDataStrAndTimeStrToLocalData(this.beginDateStr, this.beginTimeStr);
    },

    endMoment() {
      if(this.endDateStr.length === 0) {
        return null;
      }
      if(this.endTimeStr.length === 0) {
        return null;
      }
      return convertDataStrAndTimeStrToLocalData(this.endDateStr, this.endTimeStr);
    },

    period() {
      if(this.beginMoment === null) {
        return null;
      }

      if(this.endMoment === null) {
        return null;
      }

      return {
        begin: this.beginMoment,
        end:   this.endMoment,
      };
    },
  },

  watch: {
    beginDateStr() {
      this.$emit('input', this.period);
    },

    beginTimeStr() {
      this.$emit('input', this.period);
    },

    endDateStr() {
      this.$emit('input', this.period);
    },

    endTimeStr() {
      this.$emit('input', this.period);
    },
  }
};
</script>

<style scoped>
  .period-table > tr > td {
    padding-right: 0.4em;
    padding-bottom: 0.4em;
  }
</style>
